const LocalStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }    
  
  function _setBrandingInfo(obj) {
    localStorage.setItem('brandingInfo', obj);
  }
  
  function _getBrandingInfo() {
    return localStorage.getItem('brandingInfo');
  }

  function _setAccessToken(obj) {
    localStorage.setItem('accessToken', obj.accessToken);
    localStorage.setItem('username', obj.username);
    localStorage.setItem('refreshToken', obj.refreshToken);
    localStorage.setItem('clientID', obj.clientID);
    localStorage.setItem('tokenTimestamp', obj.tokenTimestamp);
    localStorage.setItem('provider', obj.provider);
  }
  function _getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  function _clearToken() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('clientID');
    localStorage.removeItem('tokenTimestamp');
    localStorage.removeItem('username');
    localStorage.removeItem('provider');
  }

  return {
    getService: _getService,
    setBrandingInfo: _setBrandingInfo,
    getBrandingInfo: _getBrandingInfo,
    setAccessToken: _setAccessToken,
    getAccessToken: _getAccessToken,
    clearToken: _clearToken,
  };
})();
export default LocalStorageService;
  